import Vue from 'vue';
import VueI18n from 'vue-i18n';
import app from './app.vue';
import store from './store';
import { userLocale } from './locale';
import ru from './assets/locale/ru.json';
import en from './assets/locale/en.json';
import fr from './assets/locale/fr.json';

Vue.config.productionTip = false;

require('./assets/styles/main.scss');

store.dispatch('changeLanguage', userLocale);

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: userLocale,
  fallbackLocale: userLocale,
  messages: {
    ru,
    en,
    fr,
  },
});

new Vue({
  i18n,
  store,
  render: h => h(app)
}).$mount('#app');
